import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import DeleteMemberModal from './modal/delete_member';
import EditMemberModal from './modal/edit_member';
import ImageClass from '../../assets';
import { settingSelectedTeamMember } from '../../redux/slices/team';
import { TeamMemberObject } from '../../params/redux/team';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, IconButton, Typography } from '@mui/material';
import { Delete, Edit, EmailOutlined, PhoneOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

interface TeamCardProps {
    search: string;
    sort: boolean;
}


const TeamCardComponent = ({ sort, search }: TeamCardProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [editing, setEditing] = useState<number | null>(null);
    const [deleting, setDeleting] = useState<number | null>(null);
    const { teams } = useSelector((state: RootState) => state.team);

    // **Filter and Sort Logic**
    const filteredMembers = teams.filter((member: TeamMemberObject) => {
        const name = `${member.first_name || ''} ${member.last_name || ''}`.toLowerCase();
        const email = member.email?.toLowerCase() || '';
        const phone = member.phone_number;
        return (
            !search ||
            name.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            phone.includes(search)
        );
    });

    const sortedMembers = sort
        ? [...filteredMembers].sort((a, b) => a.email.localeCompare(b.email))
        : filteredMembers;

    const handleDeleteSelection = (value: TeamMemberObject) => {
        dispatch(settingSelectedTeamMember(value));
        setDeleting(value.id);
        // dispatch(settingSelectedCustomer(value));
        // setDeleteModal();
    };

    const editDealHandler = (value: TeamMemberObject) => {
        dispatch(settingSelectedTeamMember(value));
        setEditing(value.id);
        // dispatch(settingSelectedCustomer(value));
        // setEditModal();
    };

    return <Box display="flex" gap={2} flexWrap="wrap" overflow="auto">
        {sortedMembers.map((row) => (
            <Box key={row.id} minWidth="445px">
                <CardWrapper>
                    <Box p={1}>
                        <Box display="flex" justifyContent="space-between" alignItems="start" mb={2}>
                            <Box display="flex" gap={1} >
                                <Box>
                                    <img src={ImageClass.userPlacedholder} alt="User placehodler" style={{
                                        borderRadius: '50%'
                                    }} height="30px" />
                                </Box>
                                <Box display="flex" flexDirection="column">
                                    <Typography variant="h6" minWidth="200px" maxWidth="200px !important" overflow="hidden" textOverflow="ellipsis" >{row.name}</Typography>
                                    <Box bgcolor={brand[100]} width="max-content" px={1} borderRadius={1}>
                                        <Typography variant="body1" color={brand[300]}>
                                            {row?.role === 'organizationOwner'
                                                ? 'ORGANIZATION OWNER'
                                                : row?.role === 'organizationAdmin'
                                                    ? 'ORGANIZATION ADMIN'
                                                    : row?.role === 'salesMember'
                                                        ? 'SALES MEMBER'
                                                        : row?.role === 'salesManager'
                                                            ? 'SALES MANAGER'
                                                            : row?.role === 'companyManager'
                                                                ? 'COMPANY MANAGER'
                                                                : row?.role === 'client'
                                                                    ? 'CUSTOMER'
                                                                    : 'USER'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <IconButton onClick={() => editDealHandler(row)}>
                                    <Edit fontSize="small" color="info" />
                                </IconButton>
                                <IconButton onClick={() => handleDeleteSelection(row)}>
                                    <Delete fontSize="small" color="error" />
                                </IconButton>
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center" gap="5px"><EmailOutlined fontSize="small" /><Typography variant="body2">{row.email}</Typography></Box>
                            <Box display="flex" alignItems="center" gap="5px"><PhoneOutlined fontSize="small" /><Typography variant="body2">{row.phone_number}</Typography></Box>
                        </Box>
                    </Box>
                </CardWrapper>
            </Box>
        ))}
        <EditMemberModal open={Boolean(editing)} onClose={() => setEditing(null)} />
        <DeleteMemberModal open={Boolean(deleting)} onClose={() => setDeleting(null)} />
        {/* <DeleteDealModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} /> */}
    </Box>;
};

export default TeamCardComponent;